import { createContextualCan, useAbility } from "@casl/react";
import { createContext } from "react";

export const AbilityContext = createContext();
export const useCan = () => useAbility(AbilityContext);
export const Can = createContextualCan(AbilityContext.Consumer);
